




























import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import OrbitRoundScrollableTable from '@/components/orbit/OrbitRoundScrollableTable.vue'
import OrbitRoundPoolSummary from '@/components/orbit/OrbitRoundPoolSummary.vue'
import FilterCurrentRoundOrbit from '@/components/filters/FilterCurrentRoundOrbit.vue'
import LastPriceUpdated from '@/components/LastPriceUpdated.vue'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'
import {OrbitTransactionCollection} from '@/model/collection/OrbitTransactionCollection'
import {$} from '@/facade'

@Component({
  components: {
    FilterCurrentRoundOrbit,
    OrbitRoundScrollableTable,
    OrbitRoundPoolSummary,
    LastPriceUpdated,
  },
})
export default class OrbitCurrentRoundContent extends Vue {
  @Prop({type: Number, required: true}) activeRound!: number
  @Prop({type: String, required: true}) lastTimeUpdated!: string

  orbitProjectCollection = new OrbitProjectCollection()

  transactionCountMap: Record<
    number,
    {
      total: string
      your: string
    }
  > = {}

  mounted() {
    this.applyCollection()
    this.populateResources()
  }

  applyCollection() {
    this.orbitProjectCollection.round = [this.activeRound]
  }

  async populateResources() {
    this.$await.init('populateCurrentRound')

    await this.orbitProjectCollection.queryAsPage()
    await this.populateTransactionCountMap(
      $.walletAdapter.n3Address ?? undefined
    )

    this.$await.done('populateCurrentRound')
  }

  async populateTransactionCountMap(walletAddress?: string) {
    const promises = this.orbitProjectCollection.items.map(async item => {
      const projectId = item.idOrbitProjectPk

      const orbitTransactionCollection = new OrbitTransactionCollection()

      orbitTransactionCollection.round = this.activeRound
      orbitTransactionCollection.idOrbitProjectFk = projectId
      orbitTransactionCollection.limit = 1

      await orbitTransactionCollection.queryAsPage()

      const totalTransactions = String(orbitTransactionCollection.total)

      if (walletAddress) {
        orbitTransactionCollection.address = walletAddress

        await orbitTransactionCollection.queryAsPage()

        const totalYourTransactions = String(orbitTransactionCollection.total)

        this.$set(this.transactionCountMap, projectId, {
          total: totalTransactions,
          your: totalYourTransactions,
        })

        return
      }

      this.$set(this.transactionCountMap, projectId, {
        total: totalTransactions,
        your: 'N/A',
      })
    })

    await Promise.all(promises)
  }

  @Watch('$walletAdapter.n3Address')
  onWalletChange(walletAddress?: string | undefined) {
    this.populateTransactionCountMap(walletAddress)
  }
}
